import { datadogRum } from '@datadog/browser-rum'

const {
  REACT_APP_DATADOG_APPLICATION_ID,
  REACT_APP_DATADOG_CLIENT_TOKEN,
  REACT_APP_DATADOG_ENV,
  REACT_APP_DATADOG_VERSION,
} = process.env

export const initDatadog = () => {
  if (
    !REACT_APP_DATADOG_APPLICATION_ID ||
    !REACT_APP_DATADOG_CLIENT_TOKEN ||
    !REACT_APP_DATADOG_ENV
  )
    return

  datadogRum.init({
    applicationId: REACT_APP_DATADOG_APPLICATION_ID,
    clientToken: REACT_APP_DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'sales-engagement',
    env: REACT_APP_DATADOG_ENV,
    version: REACT_APP_DATADOG_VERSION || '1.0.0',
    sampleRate: 100,
    sessionReplaySampleRate: 20,
    trackInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  })

  datadogRum.startSessionReplayRecording()
}
